/**
 * 目的: 该js主要页面显示列表字段，自定义查询字段，通用查询字段上报
 * 1、触发自定义查询-查询按钮上报：上报自定义列，自定义查询数据
 * 2、触发通用查询-查询按钮上报：上报自定义列，通用查询数据
 * 3、其他类型查询上报（如触发方法）：上报自定义列
 */

import { request } from './http'
import { ENV } from '../config'
import { collectApiMap } from './common'
import { getModelValue } from './model'
import { date } from './filter'
import localforage from 'localforage'

const URL = 'cts.web.genericSearch.searchActionLog'

let userStore = localforage.createInstance({ 'name': 'globalGenericLogs' }) // { menuId + code + type: reportTime }

const REPORT_ACTION = {
  FORM: 1, // 自定义查询表单
  GENERIC: 2, // 通用查询弹框表单
  OTHER: 3 // 调用刷新api等
}

const GENERIC_TYPE = {
  FORM: 1, // 自定义查询
  GENERIC: 2, // 通用查询
  COLUMN: 3 // 自定义列
}

// 判断是否是其他类型操作
const isOtherAction = function (action) {
  return ![REPORT_ACTION.FORM, REPORT_ACTION.GENERIC].includes(+action)
}

// 日志埋点
const log = function (msg, ...args) {
  console.info(`[Fields Log]: ${msg}`, ...args)
}

function getCurrentStoreKey (data) {
  const keys = ['menuId', 'genericCode', 'queryType']
  return keys.map(key => data[key]).join('@')
}



// 获取缓存上报记录
async function getReport (data) {
  let key = getCurrentStoreKey(data)
  let time = await userStore.getItem(key)
  return time
}

// 缓存定时器停留时长，同菜单累加
async function storeReport (data) {
  const now = date(new Date())
  data.forEach(item => {
    let key = getCurrentStoreKey(item)
    userStore.setItem(key, now)
  })
}

// 跟进上报时间，判断当天是否还能上报
async function canReport (data) {
  let flag = true
  const now = date(new Date())

  for (let i = 0, len = data.length; i < len; i++) {
    let time = await getReport(data[i])
    console.log('time', time, now)
    if (time && now === time) {
      flag = false
    }
  }
  return flag
}

// http上报
async function upload (data) {
  if (!collectApiMap[ENV]) return

  // 无数据不上报
  if (data.length === 0) return


  const isReport = await canReport(data)
  if (!isReport) {
    log('未操作个性设置，当天只上报一次')
    return
  }

  const baseUrl = collectApiMap[ENV] || collectApiMap['uat']
  const headers = {
    'X-Env': ENV || 'uat'
  }

  request(baseUrl, URL, data, { headers })
  storeReport(data)
}

// 过滤通用查询编码不存在的情况，用户可能未使用配置
function filterData (data) {
  return data.filter(item => item.genericCode)
}

// 异步上报，不影响接口正常请求
function report (data) {
  setTimeout(() => {
    const _data = filterData(data)
    upload(_data)
    log('上报数据', _data)
  }, 1000)
}

// 格式化相应参数，对应后端上报数据
function formatFileds (fieldCode, fieldName, isUsed) {
  return {
    fieldCode,
    fieldName,
    usedFlag: isUsed
  }
}

// 获取通用查询编码
function getGenericCode (genericType, opt) {
  let genericCode = ''
  switch (+genericType) {
    case +GENERIC_TYPE.FORM:
      genericCode = opt.querySearchCode
      break
    case +GENERIC_TYPE.GENERIC:
      genericCode = opt.genericSearchCode
      break
    default:
      genericCode = opt.columnsSearchCode
      break
  }
  return genericCode
}

// 创建默认参数
function createDefaultParams (genericType, opt) {
  return {
    source: 'ERP',
    menuId: opt.menuId,
    apiCode: opt.method,
    queryType: isOtherAction(opt.action) ? REPORT_ACTION.OTHER : opt.action, // 操作类型
    genericCode: getGenericCode(genericType, opt) // 通用查询编码
  }
}

// 创建上报数据
function createReportData (genericType, fields, opt) {
  return {
    ...createDefaultParams(genericType, opt),
    fields
  }
}

// 扁平化自定义列数据结构
function flattenColumnsData (data) {
  let arr = []

  data.forEach(item => {
    // 扁平化处理二级头，一级头不上报
    if (item.children && item.children.length) {
      item.children.forEach(child => {
        arr.push(child)
      })
    } else {
      arr.push(item)
    }
  })

  return arr
}

// 创建自定义列上报数据
function createColumnsData (data) {
  return flattenColumnsData(data).map(item => formatFileds(item.key, item.label, item.show))
}

// 扁平化自定义查询数据结构
function flattenFormFieldsData (data) {
  let arr = []
  data.forEach(item => {
    switch (item.type) {
      case 'menu':
        item.options && item.options.forEach(o => arr.push(o))
        break
      default:
        arr.push(item)
    }
  })
  return arr
}

// 创建自定义查询上报数据
function createFormFieldsData (data, queryParams = {}) {
  return flattenFormFieldsData(data).map(item => {
    const val = getModelValue(queryParams, item.propertyName)
    let isUsed = !!val
    // 处理特殊值
    if (Array.isArray(val) && !val.length) {
      isUsed = false
    }
    return formatFileds(item.propertyName, item.label, isUsed)
  })
}

// 用于解析通用查询参数，识别通用查询哪些字段被用户使用，并打上标识
function parseGenericFieldsParams (queryParams = []) {
  let result = {}
  queryParams.forEach(item => {
    result[item.propertyName] = 1
  })
  return result
}

// 创建自定义查询上报数据
function createGenericFieldsData (data, queryParams = []) {
  const result = parseGenericFieldsParams(queryParams)
  return data.map(item => {
    const isUsed = !!result[item.propertyName]
    return formatFileds(item.propertyName, item.columnDisplayName, isUsed)
  })
}

// 自定义查询出发上报
function formSubmitReport (opt) {
  try {
    const columns = createColumnsData(opt.columns)
    const formFields = createFormFieldsData(opt.formFields, opt.formModel)
    const data = [
      createReportData(GENERIC_TYPE.COLUMN, columns, opt),
      createReportData(GENERIC_TYPE.FORM, formFields, opt)
    ]

    report(data)
  } catch (e) {
    console.error('[Fields Log]', e)
  }
}

// 通用查询查询触发上报
function genericSubmitReport (opt) {
  try {
    const columns = createColumnsData(opt.columns)
    const genericFields = createGenericFieldsData(opt.genericFields, opt.genericVos)
    const data = [
      createReportData(GENERIC_TYPE.COLUMN, columns, opt),
      createReportData(GENERIC_TYPE.GENERIC, genericFields, opt)
    ]

    report(data)
  } catch (e) {
    window._apm && window._apm('captureException', new Error(`【ERP:fieldsLog】${e}`))
  }
}

// 通用查询查询触发上报
function otherReport (opt) {
  try {
    const columns = createColumnsData(opt.columns)
    const data = [
      createReportData(GENERIC_TYPE.COLUMN, columns, opt),
    ]

    report(data)
  } catch (e) {
    console.error('[Fields Log]', e)
  }
}

// 控制模块是否上报
function useReportByMenuId (menuId) {
  // 本地环境不上报
  if (!ENV) {
    return false
  }

  const lookup = window.__ERPLOOKUP__ ? window.__ERPLOOKUP__.find(x => x.code === 'sys_generic_serach_report_module') : null
  const list = lookup && lookup.value
  // 无数据字典上报
  if (!list || !list.length) {
    return true
  }

  const findIndex = list.findIndex(e => e.lookupValue && e.lookupCode && e.lookupCode === String(menuId))
  return findIndex > -1
}


/**
 * mneuId: 菜单id
 * opt:
 *  {
 *    codes 通用查询编码
 *
 *  }
 */
export function updateReportTimeByCodes (menuId, codes = []) {
  if (!menuId || !codes || !codes.length) {
    return
  }

  try {
    userStore.keys().then(res => {
      res = res || []
      res.forEach(key => {
        const findKey = codes.find(code => key.indexOf(`${menuId}@${code}`))
        findKey && userStore.removeItem(key)
      })
    })
    log('清除缓存', codes)
  } catch (e) {
    window._apm && window._apm('captureException', new Error(`【ERP:fieldsLog】${e}`))
  }
}


/**
 * opt:
 *  {
 *    menuId 菜单id
 *    action 触发方式
 *    method 接口
 *    columns 自定义列数据
 *    columnsSearchCode 自定义列编码
 *    formFields 自定义查询数据
 *    querySearchCode 自定义查询编码
 *    formModel 查询表单内容
 *    genericSearchCode 通用查询编码
 *    genericFields  通用查询数据
 *    genericVos  通用查询vos
 *  }
 */
export function genericSearchFieldsUpload (opt) {
  log('上报参数', opt)

  // 菜单id未获取不上报
  if (!opt.menuId) {
    return
  }

  if (!useReportByMenuId(opt.menuId)) {
    return
  }

  // 根据类型上报相应数据格式
  switch (+opt.action) {
    case +REPORT_ACTION.FORM:
      formSubmitReport(opt)
      break
    case +REPORT_ACTION.GENERIC:
      genericSubmitReport(opt)
      break
    default:
      otherReport(opt)
      break
  }
}




// WEBPACK FOOTER //
// ./src/public/utils/fields-log.js